import { render, staticRenderFns } from "./reportControl.vue?vue&type=template&id=2835a97e&scoped=true&"
import script from "./reportControl.vue?vue&type=script&lang=js&"
export * from "./reportControl.vue?vue&type=script&lang=js&"
import style0 from "./reportControl.vue?vue&type=style&index=0&id=2835a97e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2835a97e",
  null
  
)

component.options.__file = "reportControl.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib'
installComponents(component, {
  VFlex,
})
